import { HttpHandlerFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, delay, of, switchMap, tap } from 'rxjs';

const loadingSubject = new BehaviorSubject<boolean>(false);

// switchMap cancels a pending delayed `false` when a new `true` arrives,
// preventing stale "not loading" emissions from earlier requests from
// hiding the loader while a later request is still in flight.
// delay(0) on `true` avoids ExpressionChangedAfterItHasBeenCheckedError.
export const loading$ = loadingSubject
  .asObservable()
  .pipe(
    switchMap((isLoading) => of(isLoading).pipe(delay(isLoading ? 0 : 100))),
  );

let xhrCreations = 0;
let xhrResolutions = 0;

function updateLoadingStatus() {
  const isLoading = xhrResolutions < xhrCreations;
  if (loadingSubject.value !== isLoading) {
    loadingSubject.next(isLoading);
  }
}

function shouldShowLoading(req: HttpRequest<any>): boolean {
  const params = req.params;
  const data = req.body as any;
  return !(params?.get('silent') || data?.silent);
}

export function loadingInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) {
  const tracked = shouldShowLoading(req);

  if (tracked) {
    xhrCreations++;
    updateLoadingStatus();
  }

  return next(req).pipe(
    tap({
      next: (event) => {
        if (event instanceof HttpResponse && tracked) {
          xhrResolutions++;
          updateLoadingStatus();
        }
      },
      error: () => {
        if (tracked) {
          xhrResolutions++;
          updateLoadingStatus();
        }
      },
    }),
  );
}
